import { render, staticRenderFns } from "./ReservationTypeBadge.vue?vue&type=template&id=24a502a3&scoped=true&"
import script from "./ReservationTypeBadge.vue?vue&type=script&lang=js&"
export * from "./ReservationTypeBadge.vue?vue&type=script&lang=js&"
import style0 from "./ReservationTypeBadge.vue?vue&type=style&index=0&id=24a502a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a502a3",
  null
  
)

export default component.exports